export const mapEntriesToOptions = ([value, label]) => ({ value, label });
